module.exports = __webpack_public_path__ + "media/images/emblems/Langendorf-blason-f9ae3cd4badc551c114bd87fb83fe7d0.png";